import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
import { site } from '../../data/site';
import { ButtonLink } from '../ui/ButtonLink';
import { Container } from '../ui/Container';
import { Reveal } from '../ui/Reveal';
import { SectionTitle } from '../ui/SectionTitle';
export function Visit() {
  return <section id="visit" aria-labelledby="visit-title" className="bg-paper py-20 lg:py-28" data-id="element-349" data-mp="ta0uwzazjd53">
      <Container className="grid gap-12 lg:grid-cols-12 lg:gap-16" data-id="element-350" data-mp="1gyaahjhlv4ns">
        <Reveal className="lg:col-span-5" data-id="element-351" data-mp="1lxmw60wqq5os">
          <SectionTitle id="visit-title" data-id="element-352" data-mp="1lwlidoocb53d">Visit the school</SectionTitle>
          <p className="text-pretty mt-6 text-[1.05rem] leading-relaxed text-muted" data-id="element-353" data-mp="17yevf3kxipih">
            Bates Taekwondo is on Richmond Dr NE in Albuquerque. Classes run on weekdays. Call or email and ask which
            current class suits you or your child.
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row" data-id="element-354" data-mp="3sqh0eh1jnrzb">
            <ButtonLink href={site.directionsUrl} external icon={<ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-356" data-mp="9hj6waem05xe" />} data-id="element-355" data-mp="l3c8v2v3ebt">
              Get directions
            </ButtonLink>
            <ButtonLink href={site.phoneHref} variant="secondary" data-id="element-357" data-mp="4jhl3hpstsi8">
              Call {site.phoneDisplay}
            </ButtonLink>
          </div>
        </Reveal>

        <dl className="border-b border-line lg:col-span-7" data-id="element-358" data-mp="egvs6qpu14xv">
          <Row term="Address" data-id="element-359" data-mp="efazl6n2vw2n">
            <address className="not-italic" data-id="element-360" data-mp="ej8h5nu0cfkf">
              <span className="block font-display text-[2rem] font-bold uppercase leading-none sm:text-[2.4rem]" data-id="element-361" data-mp="sflquasavcoc">{site.street}</span>
              <span className="mt-1 block text-lg" data-id="element-362" data-mp="nhaik4hnla88">{site.cityLine}</span>
            </address>
          </Row>
          <Row term="Phone" data-id="element-363" data-mp="128jfkynvxxve">
            <a href={site.phoneHref} className="text-lg font-semibold hover:text-brand" data-id="element-364" data-mp="x6tzh4lt2u0g">
              {site.phoneDisplay}
            </a>
          </Row>
          <Row term="Email" data-id="element-365" data-mp="1b7ehvznt6ntf">
            <a href={site.emailHref} className="break-all text-lg font-semibold hover:text-brand" data-id="element-366" data-mp="1681zps7vu4x6">
              {site.email}
            </a>
          </Row>
          <Row term="Classes" data-id="element-367" data-mp="3w73cvll89mi">
            <p className="text-lg" data-id="element-368" data-mp="3ssyngpgbobw">Weekdays</p>
            <p className="mt-1 text-[15px] text-muted" data-id="element-369" data-mp="8us18oddah7s">Ask the school for the current class that fits your age and experience.</p>
          </Row>
        </dl>
      </Container>
    </section>;
}
function Row({
  term,
  children
}: {
  term: string;
  children: React.ReactNode;
}) {
  return <div className="grid gap-2 border-t border-line py-6 sm:grid-cols-[140px_1fr] sm:gap-6" data-id="element-370" data-mp="mlwvtc1vojb9">
      <dt className="pt-1 text-sm font-semibold uppercase tracking-[0.12em] text-muted" data-id="element-371" data-mp="rjovis8rl9q0">{term}</dt>
      <dd data-id="element-372" data-mp="wirv3x5z6nql">{children}</dd>
    </div>;
}